import XPReport from './src/index'

export default XPReport
